export { default } from './BlockMarquee'